import React from 'react';
import {
  Typography,
  Grid,
  Paper,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CustomerDataTabProps {
  customerData: any;
}

const CustomerDataTab: React.FC<CustomerDataTabProps> = ({ customerData }) => {
  const { t } = useTranslation();

  const renderField = (label: string, value: string | number | React.JSX.Element | null | undefined) => {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body1">
          {value || '-'}
        </Typography>
      </Box>
    );
  };

  const address = <span>
      { customerData.businessName }<br/>
      { customerData.streetOne }<br/>
      { (customerData.streetTwo !== null && <>{customerData.streetTwo}<br/></>) }
      { customerData.zipCode } { customerData.city }
  </span>;

  const taxNumber = customerData.taxNumber && customerData.taxNumberLocal
    ? `${customerData.taxNumber} (${customerData.taxNumberLocal})`
    : customerData.taxNumber || customerData.taxNumberLocal || '-';

  return (
    <Box sx={{ p: 1, height: '100%', overflow: 'auto' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.paper' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('assistant.reviewStep.customer')}
            </Typography>
            {renderField(t('customers.customerNumber'), customerData.customerNumber)}
            {renderField(t('assistant.customerConnectStep.ownerLabel'), customerData.owner)}
            {renderField(t('pages.customerDetail.business'), address)}
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.paper' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('common.contact')}
            </Typography>
            {renderField(t('customers.contactPerson'), customerData.contactPerson)}
            {renderField(t('customers.phone'), customerData.phoneNumber)}
            {renderField(t('customers.email'), customerData.emailAddress)}
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.paper' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('customers.taxInfo')}
            </Typography>
            {renderField(t('customers.taxNumber'), taxNumber)}
            {renderField(t('customers.vatId'), customerData.vatId)}
            {renderField(t('customers.taxId'), customerData.taxId)}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerDataTab;
